import { FeatureFlags } from 'yeself-common/typings/FeatureFlags';

export const FEATURE_FLAGS_SET_FLAGS = 'featureFlags/SET_FLAGS';

type FeatureFlagsSetFlagsAction = {
    type: typeof FEATURE_FLAGS_SET_FLAGS;
    payload: FeatureFlags;
};

export const featureFlagsSetFlags = (payload: FeatureFlags): FeatureFlagsSetFlagsAction => ({
    type: FEATURE_FLAGS_SET_FLAGS,
    payload,
});

export type FeatureFlagsActionTypes = FeatureFlagsSetFlagsAction;
